import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";
import moment from "moment";
// import ReactGA from "react-ga4"


// ReactGA.initialize("G-FJ1HM8S5ZX");

let db = null;
let storage = null;

const environment = "ace-live"; // live or staging or it or
// admin set code 
let myAdmin = "";
export const setMyAdmin = (userId) => {
    myAdmin = userId;
};
export { myAdmin };
// 
export const isSuperAdmin = "gvb1hjj23n";
// demostaging
const positionBadges = {
    1: require("../assets/img/icons/leaderboard/first.png").default,
    2: require("../assets/img/icons/leaderboard/2nd.png").default,
    3: require("../assets/img/icons/leaderboard/3rd.png").default,
};
const achievementBadges = {
    speedDemon: require("../assets/img/icons/achievements/timer.png").default,
    mostlyRight: require("../assets/img/icons/achievements/postive-answer.png")
        .default,
    highAchiever: require("../assets/img/icons/achievements/high-score.png")
        .default,
    streakOf10: require("../assets/img/icons/achievements/accurate-answer.png")
        .default,
};
const progressColors = {
    low: "#f5365c",
    average: "#fb6340",
    satisfactory: "#5e72e4",
    success: "#2dce89",
};

export const filterMiniGames = [
  { value: 3, gameName: 'Word Scramble', competency: 'Aptitude', label: "Mini 3" },
  { value: 4, gameName: 'Set the shelf', competency: 'Cognitive',  label: "Mini 4" },
  { value: 5, gameName: 'Cosmic Quest', competency: 'Aptitude',  label: "Mini 5" },
  { value: 6, gameName: 'Headlines', competency: 'Cognitive',  label: "Mini 6" },
  { value: 7, gameName: 'Choas warhouse', competency: 'Aptitude',  label: "Mini 7" },
  { value: 8, gameName: 'Mindful Menu', competency: 'Cognitive', label: "Mini 8" },
  { value: 9, gameName: 'Graph interpretation', competency: 'Aptitude',  label: "Mini 9" },
  { value: 10, gameName: "Solver's Leap", competency: 'Aptitude',  label: "Mini 10" },
];

export const imageMap = {
  topBun: require("../assets/img/questionnaire/miniGame8/topBun.png"),
  patty: require("../assets/img/questionnaire/miniGame8/patty.png"),
  cheese: require("../assets/img/questionnaire/miniGame8/cheese.png"),
  baseBun: require("../assets/img/questionnaire/miniGame8/baseBun.png"),
  drink: require("../assets/img/questionnaire/miniGame8/drink.png"),
  bacon: require("../assets/img/questionnaire/miniGame8/bacon.png"),
  lettuce: require("../assets/img/questionnaire/miniGame8/lettuce.png"),
  mustard: require("../assets/img/questionnaire/miniGame8/mustard.png"),
  egg: require("../assets/img/questionnaire/miniGame8/egg.png"),
  tomato: require("../assets/img/questionnaire/miniGame8/tomato.png"),
  sausage: require("../assets/img/questionnaire/miniGame8/sausage.png"),
  cucumber: require("../assets/img/questionnaire/miniGame8/cucumber.png"),
  onion: require("../assets/img/questionnaire/miniGame8/onion.png"),
  ketchup: require("../assets/img/questionnaire/miniGame8/ketchup.png"),
};

export const levelNames = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "Mini 1",
    "Mini 2",
    "Mini 3",
    "Mini 4",
];
export const miniGames = [
    {value : "Mini 1", label : "Mini 1"},
    {value : "Mini 2", label : "Mini 2 Word Sequence"},
    {value : "Mini 3", label : "Mini 3 Word Scramble"},
    {value : "Mini 4", label : "Mini 4 Set the Shelf"},
    {value : "Mini 5", label : "Mini 5 Cosmic Quest"},
    {value : "Mini 6", label : "Mini 6 Headlines"},
    {value : "Mini 7", label : "Mini 7 Chaos Warehouse"},
    {value : "Mini 8", label : "Mini 8 Mindful Menu"},
    {value : "Mini 9", label : "Mini 9 Graph Interpretation"},
    {value : "Mini 10", label : "Mini 10 Solver's Leap"},
    {value : "Mini 11", label : "Mini 11 Pattern"},
    {value : "Mini 12", label : "Mini 12 Healthcare"},
];

export const RESPONSE_ENUM = {
    1: "BEST",
    2: "OK",
    3: "WRONG",
};

export const getCapabilityColor = (index, alpha = 100) => {
    // alpha = alpha/100;
    alpha = 1;
    const colors = [
        `rgba(4, 115, 231, ${alpha})`,
        `rgba(255, 71, 4, ${alpha})`,
        `rgba(13, 144, 6, ${alpha})`,
        `rgba(132, 2, 231, ${alpha})`,
    ];

    return colors[index % colors.length];
};

export const capabilityStyles = (index, alpha) => {
    const color = getCapabilityColor(index, alpha);

    return {
        textSize: "0.875em",
        pathColor: color,
        textColor: "#32325d",
        trailColor: "#f4f5f7",
        backgroundColor: "#3e98c7",
    };
};

export const progressStyles = (name, value) => {
    let pathColor = null;
    if (value >= 80) {
        pathColor = progressColors.success;
    } else if (value >= 60) {
        pathColor = progressColors.satisfactory;
    } else if (value >= 40) {
        pathColor = progressColors.average;
    } else {
        pathColor = progressColors.low;
    }

    return {
        textSize: "0.875em",
        pathColor: pathColor,
        textColor: "#adb5bd",
        trailColor: "#f4f5f7",
        backgroundColor: "#3e98c7",
    };
};

const mode = "light"; //(themeMode) ? themeMode : 'light';
const fonts = {
    base: "Open Sans",
};

export const colors = {
    gray: {
        100: "#f6f9fc",
        200: "#e9ecef",
        300: "#dee2e6",
        400: "#ced4da",
        500: "#adb5bd",
        600: "#8898aa",
        700: "#525f7f",
        800: "#32325d",
        900: "#212529",
    },
    0: "rgb(17,200,239)",
    1: "rgb(17,175,239)",
    2: "rgb(17,150,239)",
    3: "rgb(17,125,239)",
};
export const multiselectDropdownStyle = {
    chips: {
        background: "#5e72e4",
        fontSize: ".75rem",
        padding: "1px 10px",
        marginBottom: "0",
        color: "#ffffff",
    },
    searchBox: {
        border: "none",
        // "background": "#FFFFFF",
        minHeight: "calc(1.5em + 1.25rem + 2px)",
        fontWeight: "400",
        padding: "0.625rem 0.75rem",
        lineHeight: "1.5",
        fontSize: "0.8rem",
    },
};

export const lineChartOptions = {
    scales: {
        xAxes: [
            {
                // gridLines: {
                // display: false
                // }
            },
        ],
        yAxes: [
            {
                // gridLines: {
                //     display: false
                //     // color: colors.gray[900],
                //     // zeroLineColor: colors.gray[900],
                // },
                ticks: {
                    beginAtZero: true,
                },
            },
        ],
    },
};

export const barGraphOptions = {
    scales: {
        xAxes: [
            {
                gridLines: {
                    display: false,
                    drawBorder: false,
                    drawOnChartArea: false,
                    drawTicks: false,
                },
                ticks: {
                    padding: 20,
                },
            },
        ],
        yAxes: [
            {
                gridLines: {
                    display: true,
                    drawBorder: false,
                    drawTicks: false,
                    color: colors.gray[200],
                    zeroLineColor: colors.gray[200],
                },
                ticks: {
                    beginAtZero: true,
                    padding: 20,
                },
            },
        ],
    },
};

export const leaderboardExportHeaders = [
    { displayName: "Rank", id: "rank" },
    { displayName: "Name", id: "name" },
    { displayName: "Email", id: "email" },
    { displayName: "Progress", id: "currentLevel" },
    { displayName: "Completed", id: "completedOnce" },
    { displayName: "Score", id: "currentScore" },
    { displayName: "Tries", id: "attempts" },
    { displayName: "Last Updated", id: "lastUpdated" },
    { displayName: "Filters", id: "filters" },
];

export const getDb = () => {
    if (db) {
        return db;
    } else {
        db = getFirestore();
        return db;
    }
};

export const getStorageObject = () => {
    if (storage) {
        return storage;
    } else {
        storage = getStorage();
        return storage;
    }
};

export const firebaseConstants = {
    dbAnswers: "answers",
    dbResults: "results",
    dbUsers: "users",
    dbAdmins: "admins",
    dbRegions: "regions",
    dbDepartments: "departments",
    dbDifficulties: "levelDifficultyScores",
    dbUtil: "util",
    firebaseConfig:
        environment === "live"
            ? {
                apiKey: "AIzaSyDerK2QN-d1fRrJYuNGsifX7IBDFoH50Zc",
                authDomain: "advance-progression-game.firebaseapp.com",
                projectId: "advance-progression-game",
                storageBucket: "advance-progression-game.appspot.com",
                messagingSenderId: "746550489487",
                appId: "1:746550489487:web:566666b26228db46479bfa",
            }
            : environment === "staging"
                ? {
                    apiKey: "AIzaSyD1VEEjl3ReLqLtr5d1xzHrcP4mcyo_Vg8",
                    authDomain: "progress-staging.firebaseapp.com",
                    projectId: "progress-staging",
                    storageBucket: "progress-staging.appspot.com",
                    messagingSenderId: "991147661809",
                    appId: "1:991147661809:web:cb3854f53baf0cf7494c50",
                }
                : environment === "progress-it"
                    ? {
                        apiKey: "AIzaSyA7ea6fcrnHXYfJBRyt8HAZnoNL0K5QNJQ",
                        authDomain: "progress-it-ef958.firebaseapp.com",
                        projectId: "progress-it-ef958",
                        storageBucket: "progress-it-ef958.appspot.com",
                        messagingSenderId: "328066569672",
                        appId: "1:328066569672:web:cb4c431adf36c85e169cfd",
                    }
                    : environment === "progress-assessment"
                        ? {
                            apiKey: "AIzaSyBfLwgXMUwTxzRpuqyRX3WHxgb07ujT_ek",
                            authDomain: "progressgame-assessment-v1.firebaseapp.com",
                            projectId: "progressgame-assessment-v1",
                            storageBucket: "progressgame-assessment-v1.appspot.com",
                            messagingSenderId: "499114733920",
                            appId: "1:499114733920:web:0f8f04f1144d4b569eee05",
                        }
                        : environment === "demo"
                            ? {
                                apiKey: "AIzaSyBql5763UBaCJN3amdOs91Fw2CRG6edNAM",
                                authDomain: "progress-demoassesment.firebaseapp.com",
                                projectId: "progress-demoassesment",
                                storageBucket: "progress-demoassesment.appspot.com",
                                messagingSenderId: "536188773178",
                                appId: "1:536188773178:web:27d067f0d81710e16da603",
                            }
                            : environment === "ace-live"
                                ? {
                                    apiKey: "AIzaSyA1y0Ar8Nen3BIsdkRLjneYOUmYxRsNj-E",
                                    authDomain: "ace-live-b9d58.firebaseapp.com",
                                    projectId: "ace-live-b9d58",
                                    storageBucket: "ace-live-b9d58.appspot.com",
                                    messagingSenderId: "752649546785",
                                    appId: "1:752649546785:web:8c1dd6a7f90f159dd30760"
                                }
                                : environment === "progress-live"
                                    ? {
                                        apiKey: "AIzaSyDYPkjJsD-QtZwfg-v2veporcOIQhuTFWg",
                                        authDomain: "progress-live-v1.firebaseapp.com",
                                        projectId: "progress-live-v1",
                                        storageBucket: "progress-live-v1.appspot.com",
                                        messagingSenderId: "206063128092",
                                        appId: "1:206063128092:web:71fae7596283f97fc859d9"
                                    }
                                    :environment === "progress-pepsico"?{
                                        apiKey: "AIzaSyCVW4yZR_kun6Q0TgkjPlIjtfBa3ZgsLBo",
                                        authDomain: "pepsico-progress.firebaseapp.com",
                                        projectId: "pepsico-progress",
                                        storageBucket: "pepsico-progress.appspot.com",
                                        messagingSenderId: "58684782140",
                                        appId: "1:58684782140:web:46d3dab1f7365ed67db539"
                                    }
                                    :environment === "ace-public-live"?{
                                            apiKey: "AIzaSyC_FSvNtsr1U8rqzi0iDtw-r5prdcw_IQA",
                                            authDomain: "ace-public-live.firebaseapp.com",
                                            projectId: "ace-public-live",
                                            storageBucket: "ace-public-live.appspot.com",
                                            messagingSenderId: "275041295700",
                                            appId: "1:275041295700:web:6811fb0abed04dea673cc1"
                                    }
                                    :environment === "progress-public-live"?{
                                            apiKey: "AIzaSyBvcBL_XoUvV0sN31HXarTdacJ8eQfArOA",
                                            authDomain: "progress-public-live.firebaseapp.com",
                                            projectId: "progress-public-live",
                                            storageBucket: "progress-public-live.appspot.com",
                                            messagingSenderId: "56294952399",
                                            appId: "1:56294952399:web:6ff2b503ac06cdb92f16ba"
                                    }: {
                                        apiKey: "AIzaSyDHnsgmNWthV1-K0mXtNB2NaWXJbL0kd5s",
                                        authDomain: "progress-stagingassessment.firebaseapp.com",
                                        projectId: "progress-stagingassessment",
                                        storageBucket: "progress-stagingassessment.appspot.com",
                                        messagingSenderId: "870077185846",
                                        appId: "1:870077185846:web:13f2b7a0e41d7a261a3d97",
                                    },
};

export const getPositionBadge = (position) => {
    const value = positionBadges[position];
    return value
        ? value
        : `https://via.placeholder.com/30x30/FFFFFF/000000?text=${position}`;
};

export const getAchievementBadge = (achievementName) => {
    return achievementBadges[achievementName];
};

export const renderDay = (
    props,
    currentDate,
    selectedDate,
    startDate,
    _endDate
) => {
    const endDate = moment(_endDate).subtract(24, "hours");

    let classes = props.className;
    if (startDate && endDate && startDate._d + "" === currentDate._d + "") {
        classes += " start-date";
    } else if (
        startDate &&
        endDate &&
        new Date(startDate._d + "") < new Date(currentDate._d + "") &&
        new Date(endDate._d + "") > new Date(currentDate._d + "")
    ) {
        classes += " middle-date";
    } else if (endDate && endDate._d + "" === currentDate._d + "") {
        classes += " end-date";
    }
    return (
        <td {...props} className={classes}>
            {currentDate.date()}
        </td>
    );
};

export const getPercentageChange = (oldNumber, newNumber) => {
    const decreaseValue = newNumber - oldNumber;
    return oldNumber > 0 ? (decreaseValue / oldNumber) * 100 : 100;
};

export const plans = [
    {
        name: 'Standard',
        price: '$10',
        features: [
            '50 Candidates',
            '1 Assessment game',
            'Single user invite',
            'Fixed Competencies',
            'Reports'
        ]
    },
    {
        name: 'Premium',
        price: '$100',
        features: [
            '200 Candidates',
            '2 Assessment games',
            'Bulk user invite',
            'Fixed Competencies',
            'Reports'
        ]
    },
    {
        name: 'Business',
        price: 'Contact',
        features: [
            '1000+ users',
            'Unlimited Events',
            'Bulk User upload',
            'Select competencies from list',
            'Reports',
            'Custom Branding'
        ]
    }
];

export const packages = {
    free: {
        plan: "free",
        maxAssessments: 1,
        maxUsers: 15,
    },
    standard: {
        plan: "standard",
        maxAssessments: 1,
        maxUsers: 50,
    },
    premium: {
        plan: "premium",
        maxAssessments: 2,
        maxUsers: 200,
    },
};

export const packageLinks = {
    standard: "https://buy.stripe.com/test_28o8Ak7Od1QfgLe144",
    premium: "https://buy.stripe.com/test_28ocQA2tTeD1cuYdQR",
}


export const trackGA4Event = (type, data, projectType) => {
    const eventPayload = {
        event_category: type,
        event_label: data,
    };
    let eventName = projectType + ".activ8games.com";
    // ReactGA.event(eventName, eventPayload);
};
